/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "save",
	init: init,
	triggers: triggers,
	handle_counter_change: handle_counter_change
});

function init() {
	this._counter = 0;
	this.push(false);
}

function triggers() {
	return {
		"start": start_save,
		"finish": finish_save,
	};
}

function start_save() {
	this._counter += 1;
	this.handle_counter_change();
}

function finish_save() {
	this._counter -= 1;
	this.handle_counter_change();
}

function handle_counter_change() {
	if (this._counter < 0)
		this._counter = 0;
	if (this._counter === 0 && this.data === true)
		this.push(false);
	if (this._counter > 0 && this.data === false)
		this.push(true);
}
